/**
 * scripts.js
 */
import $ from "jquery";
import Drupal from "Drupal";
import drupalSettings from "drupalSettings";
import {preventDefault} from "ol/events/Event";
import {display} from "@splidejs/splide/src/js/utils";


(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.saipem_form = {
    attach: function (context, settings) {

      once('saipem-input', 'input', context).forEach(
        function (element) {
            if($(element).val()!="" && $(element).attr('type')!='checkbox')
            {
              $(element).closest('.form-item').addClass('value-changed');
            }
            else
            {
              $(element).closest('.form-item').removeClass('value-changed');
            }

          $(element).change(function(){
            if($(this).val()!=""  && $(this).attr('type')!='checkbox')
            {
              $(this).closest('.form-item').addClass('value-changed');
            }
            else
            {
              $(this).closest('.form-item').removeClass('value-changed');
            }

          })
        }
      );

      once('saipem-form-text-area', 'textarea', context).forEach(
        function (element) {
          $(element).attr('rows',1);
        }
      );

      once('saipem-form', 'form.webform-submission-form', context).forEach(
        function (element) {
          $(element).addClass('col-md-8');
        }
      );

    }
  };




})(jQuery, Drupal, drupalSettings);
